var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-style":"italic","padding":"5px 0px","margin-top":"5px"},domProps:{"innerHTML":_vm._s(_vm.message.AttachmentFile.Payload.ErrorMessage)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29114edc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Messenger/MessageList/Message/MessageAttachment/ErrorPayload.vue
// module id = n1sd
// module chunks = 1